<template>
  <VPage
    class="error-page"
  >
    <div class="content">
      <div class="error-number">
        {{ errorNumber }}
      </div>
      <h1>
        {{ getErrorTitle }}
      </h1>
    </div>
  </VPage>
</template>

<script lang="ts">
export default defineComponent({
	name: 'ErrorPage',
	props: {
		errorNumber: {
			type: String,
			default: '404',
		},
	},

	data() {
		return {
			errors: {
				404: {
					title: 'Страница не найдена',
				},
				403: {
					title: 'Доступ запрещен',
				},
				500: {
					title: 'Ошибка сервера',
				},
			},
		};
	},

	computed: {
		getErrorTitle() {
			if (typeof this.errorNumber !== 'string') return this.errors['404'].title;
			return this.errors[this.errorNumber].title;
		},
	},
});
</script>

<style lang="scss" src="./ErrorPage.scss" />
